import { Component } from '@ecs/Component';

export class ShieldProjector implements Component {
  readonly type = 'ShieldProjector';

  constructor(
    public range: number = 140,
    public rechargePerSecond: number = 0.6 // shield points per second to each ally in range
  ) {}
}
